export enum OrderDiscountTypeEnum {
  Percentage = 1,
  FixedAmount = 2,
}
